export const modules = ['Real estate', 'Shopping', 'Hotel'];
export const hotleTypes = ['Casino Hotel', 'Resorts', 'Inns', 'Suite', 'Motel'];
export const numberOfRooms = [
  '0 - 10 rooms',
  '10 - 20 rooms',
  '20 - 30 rooms',
  '30 - 40 rooms',
  '50 rooms & more'
];
export const hotelRatings = [
  '1 star',
  '2 star',
  '3 star',
  '4 star',
  '5 star',
  'AAA Five Diamond Award'
];
export const facilities = [
  '24h Power supply',
  'Event hall',
  'Laundry services',
  'Bar & Lounge',
  '5 star',
  'Event hall'
];

export const propertyType = ['Rent', 'Lease', 'Buy'];
export const roomTypesArr = ['Standard room', 'Executive rooms', 'Suites'];
export const landUnit = ['Plot', 'Acre', 'Hectare'];
